import { useEffect } from "react"
import { FixedHeightStrategy, AlternativeHeightStrategy } from "./heightsIframe"

const useIframeHeight = (isChatOpen) => {
  useEffect(() => {
    const strategy = isChatOpen ? new FixedHeightStrategy() : new AlternativeHeightStrategy()
    const height = strategy.getHeight()

    window.parent.postMessage({ height }, "*")
  }, [isChatOpen])
}

export default useIframeHeight